
import * as Tone from 'tone';
import _ from 'lodash'
import AudioEngine from '../audio-engine/AudioEngine'
import { stepTick, stepLength } from './grid'

export default class Automation {
    constructor (fxId, userId) {
        this.userId = userId
        this.fx = null
        this.setFx(fxId)
    }
    setFx (fxId) {
        this.dispose()
        if (!_.isNil(fxId)) {
            this.fxId = fxId
            this.fx = _.find(AudioEngine.busesByUser[this.userId].sortedFx, { id: this.fxId })
        }
    }
    loadSteps (steps) {
        this.clearPart()
        if (_.isNil(this.fx)) {
            return
        }
        let notes = this.convertStepsToNotes(steps)

        const toneNotes = _.cloneDeep(notes)
        for (let toneNote of toneNotes) {
            toneNote.time += 'i';
            toneNote.duration += 'i';
        }
        const fx = this.fx
        const automationOptions = fx.getAutomationOptions()
        const enabledOption = _.find(automationOptions, { name: 'enabled' })

        this.part = new Tone.Part(function (time, note) {
            //const frequency = note.isOn ? 500 : 20000
            //fx.fx.frequency.setValueAtTime(frequency, time)
            if (note.isOn) {
                enabledOption.setParameter(enabledOption.calculateValue(true), time)
            } else {
                enabledOption.setParameter(enabledOption.calculateValue(false), time)
            }

        }, toneNotes)
        // instrument parts loop one bar and the transport does not loop, so this must loop too
        this.part.loop = true
        this.part.loopEnd = '1:0:0'
        this.part.start(0)
    }
    convertStepsToNotes (steps) {
        const PPQ = Tone.getTransport().PPQ
        const totalTicks = PPQ * 4
        const n = steps.length
        let notes = []
        let currentNote;
        for (let i = 0; i < n; i++) {
            const step = steps[i]
            const ticksPerStep = stepLength(i, n, totalTicks)
            if (step.isOn) {
                if (_.isNil(currentNote)) {
                    currentNote = {
                        time: stepTick(i, n, totalTicks),
                        duration: 0
                    }
                }
                currentNote.duration += ticksPerStep
            } else {
                if (!_.isNil(currentNote)) {
                    let noteOn = _.cloneDeep(currentNote)
                    noteOn.isOn = true
                    let noteOff = _.cloneDeep(currentNote)
                    noteOff.isOn = false
                    noteOff.time = currentNote.time + currentNote.duration
                    notes.push(noteOn)
                    notes.push(noteOff)
                    currentNote = null
                } else if (i === 0) {
                    currentNote = {
                        time: 0,
                        duration: ticksPerStep
                    }
                    let noteOff = _.cloneDeep(currentNote)
                    noteOff.isOn = false
                    notes.push(noteOff)
                    currentNote = null
                }
            }
            if (i === steps.length - 1) {
                if (!_.isNil(currentNote)) {
                    let noteOn = _.cloneDeep(currentNote)
                    noteOn.isOn = true
                    let noteOff = _.cloneDeep(currentNote)
                    noteOff.isOn = false
                    noteOff.time = currentNote.time + currentNote.duration
                    notes.push(noteOn)
                    notes.push(noteOff)
                    currentNote = null
                }
            }
        }
        return notes
    }
    clearPart () {
        if (!_.isNil(this.part) && !_.isNil(this.part._events)) {
            this.part.dispose()
        }
    }
    dispose () {
        if (!_.isNil(this.fx)) {
            this.clearPart()
            // restore fx back to default (bypassed) state
            const fx = this.fx
            const automationOptions = fx.getAutomationOptions()
            const enabledOption = _.find(automationOptions, { name: 'enabled' })
            enabledOption.setParameter(enabledOption.calculateValue(false))
            this.fx = null
        }
    }
}
